import { render } from "./PopoverInput.vue?vue&type=template&id=047ae2a8&scoped=true"
import script from "./PopoverInput.vue?vue&type=script&lang=js"
export * from "./PopoverInput.vue?vue&type=script&lang=js"

import "./PopoverInput.vue?vue&type=style&index=0&id=047ae2a8&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-047ae2a8"]])

export default __exports__